'use strict';

function googleMapsInitializerFactory($window, $q, urlFactory){
    var googleApiKey = urlFactory.getGoogleApiKey();
        var asyncUrl = 'https://maps.googleapis.com/maps/api/js?v=3&libraries=places&key='+googleApiKey+'&callback=', mapsDefer = $q.defer();
    $window.googleMapsInitialized = mapsDefer.resolve;
    (function(asyncUrl, callback) {
        var script = document.createElement('script');
        script.src = asyncUrl + callback;
        document.body.appendChild(script);
    })(asyncUrl, 'googleMapsInitialized');
    return {
        mapsInitialized: mapsDefer.promise
    };
}
googleMapsInitializerFactory.$inject=['$window', '$q', 'urlFactory']
export default googleMapsInitializerFactory



// WEBPACK FOOTER //
// ./src/app/scripts/factories/googleMapsInitializerFactory.js